import { VariantProps } from 'class-variance-authority'
import { ReactNode } from 'react'

import { ControlStatus } from '@/gen/controls/v1/control_status_pb'

import { cn } from '@/lib/ui/style-helpers'

import { InsightBadge, InsightBadgeProps } from '@/components/shared/insight-badge/insight-badge'
import { INSIGHTS_LABELS } from '@/components/shared/insights/labels'
import { insightsVariants } from '@/components/shared/insights/variants'
import { Markdown } from '@/components/shared/markdown/markdown'

type InsightsProps = {
  status?: ControlStatus | undefined
  summary?: string
  details?: string
  className?: string
  title?: string
  showIcon?: InsightBadgeProps['showIcon']
  icon?: InsightBadgeProps['icon']
  children?: ReactNode
} & VariantProps<typeof insightsVariants>

export const Insights = ({
  status,
  summary,
  details,
  variant,
  className,
  title = INSIGHTS_LABELS.defaultTitle,
  showIcon,
  icon,
  children,
}: InsightsProps) => {
  return (
    <div className={cn(insightsVariants({ variant }), className)}>
      <h3
        className={cn('mb-2 !text-main-foreground-ai text-heading-xxsmall', {
          '!text-main-foreground-tertiary': variant === 'inactive',
        })}
      >
        {title}
      </h3>
      {status && <InsightBadge status={status} variant={variant} showIcon={showIcon} icon={icon} />}
      <div className='mt-2 text-main-foreground-primary text-body-default'>{summary}</div>
      {details && (
        <>
          <h4 className='mt-4 text-main-foreground-tertiary text-heading-xxsmall'>
            {INSIGHTS_LABELS.details}
          </h4>
          <Markdown>{details}</Markdown>
        </>
      )}
      {children}
    </div>
  )
}
